import type { LatestSummary } from '../types';

interface Props {
  totals: LatestSummary['totals'];
  ratios: LatestSummary['ratios'];
  deltaPct: number;
}

function formatInt(n: number): string {
  return n.toLocaleString('en-US');
}

function formatPct(n: number): string {
  return `${(n * 100).toFixed(1)} %`;
}

export function MetricCard({ totals, ratios, deltaPct }: Props) {
  const deltaLabel =
    deltaPct === 0
      ? '—'
      : `${deltaPct >= 0 ? '+' : ''}${deltaPct.toFixed(1)}%`;
  return (
    <section className="metric-card" aria-label="latest-metrics">
      <h2>最近 5 分鐘</h2>
      <div className="metric-grid">
        <div className="metric">
          <span className="metric-label">Total requests</span>
          <span className="metric-value">{formatInt(totals.total_requests)}</span>
          <span className="metric-delta">vs prev 5m: {deltaLabel}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Cache hit ratio</span>
          <span className="metric-value">{formatPct(ratios.cache_hit_ratio)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Bot ratio</span>
          <span className="metric-value">{formatPct(ratios.bot_ratio)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">5xx ratio</span>
          <span className="metric-value">{formatPct(ratios.error_5xx_ratio)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">4xx ratio</span>
          <span className="metric-value">{formatPct(ratios.error_4xx_ratio)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Unique IPs</span>
          <span className="metric-value">{formatInt(totals.unique_ips)}</span>
        </div>
      </div>
    </section>
  );
}
